import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import labels from "emun.customer/_labels";
import salesrepConfig from 'emun.salesrep/salesrep.config'

export default class CustomerVendorsPurchasedController {
	constructor(utils) {
		let $ctrl = this;
		basicController($ctrl);
		$ctrl.utils = utils;
		$ctrl.mode = "list";
		$ctrl.total = 0;
		$ctrl.colors = salesrepConfig.chartColors;
		$ctrl.chartOptions = {
			maintainAspectRatio: false,
			legend: {
				display: true,
				labels: {
					boxWidth: 5,
					fontSize: 10
				}
			},
			elements: {
				rectangle: {
					borderWidth: 1
				}
			},
			tooltips: {
				enabled: true,
				callbacks: {
					label: function (tooltipItem, data) {
						var label = data.labels[tooltipItem.index];
						let datasetLabel =
							data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
						return (
							label +
							": $" +
							datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
							"  (" +
							Math.round((datasetLabel / $ctrl.total) * 100) +
							"%)"
						);
					}
				}
			}
		};
		$ctrl.labels = labels;
		$ctrl.vendorTotals = [];
		$ctrl.vendorTotals2 = [];
		$ctrl.ytdTotal = 0;
		$ctrl.lytdTotal = 0;
		$ctrl.lytdSalesQuery = new AutoQuery({
			url:
				"QuerySalesDailyCustomerTotals.json?Fields=VendorName&Sum=OrderTotal,OrderCount&dateRange=LYTD&GroupBy=VendorId,VendorName&customerId=" +
				$ctrl.customer.id,
			autoLoad: false,
			onLoaded(args) {
				if (args.total > 0) {
					args.results.forEach(function (v) {
						$ctrl.lytdTotal += Math.round(v.sumOrderTotal);
					});
					console.debug("$ctrl.lytdTotal", $ctrl.lytdTotal);
					args.results.forEach(function (v) {
						$ctrl.vendorTotals.forEach(function (obj) {
							if (v.vendorName === obj.label) {
								obj.lytd = Math.round(v.sumOrderTotal);
								var percent = Math.round((obj.ytd / obj.lytd) * 100);
								if (obj.lytd === 0) { percent = 100; }
								if (percent < 100) {
									obj.percent = 100 - percent;
									obj.trend = 'down';
								} else if (percent > 100) {
									obj.percent = percent - 100;
									obj.trend = 'up';
								} else {
									obj.percent = 100;
									obj.trend = 'neutral';
								}
								obj.lytdVendorPercent = Math.round((v.sumOrderTotal / $ctrl.lytdTotal) * 100);
							}
						});
					});
				}
			}
		});

		$ctrl.ytdSalesQuery = new AutoQuery({
			url:
				"QuerySalesDailyCustomerTotals.json?Max=OrderDate&Fields=VendorName&Sum=OrderTotal,OrderCount&dateRange=YTD&GroupBy=VendorId,VendorName&customerId=" +
				$ctrl.customer.id,
			autoLoad: true,
			onLoaded(args) {
				$ctrl.chartLabels = [];
				$ctrl.chartData = [];
				if (args.total > 0) {
					args.results.forEach(function (v) {
						$ctrl.ytdTotal += Math.round(v.sumOrderTotal);
					});
					console.debug("$ctrl.ytdTotal", $ctrl.ytdTotal);
					args.results.forEach(function (v) {
						var obj = {
							label: v.vendorName,
							ytd: Math.round(v.sumOrderTotal),
							lytd: 0,
							percent: 100,
							trend: 'up',
							ytdVendorPercent: Math.round((v.sumOrderTotal / $ctrl.ytdTotal) * 100),
							lytdVendorPercent: 0,
							lastOrderDate: v.maxOrderDate
						};
						$ctrl.vendorTotals.push(obj);
						$ctrl.chartLabels.push(obj.label);
						$ctrl.chartData.push(Math.round(obj.ytd));
						$ctrl.total += obj.ytd;
					});
				}
				$ctrl.lytdSalesQuery.load();
			}
		});
	}

	downloadData() {
		let $ctrl = this;
		var itemsFormatted = [];

		var headers = {
			name: "Brand",
			ytd: "YTD",
			ytdVendorPercent: "YTD %",
			lytd: "LYTD",
			lytdVendorPercent: "LYTD %",
			percent: "Trend %",
			lastOrderDate: "Last Order Date"
		};

		// format the data
		$ctrl.vendorTotals.forEach((item) => {
			const date = new Date(item.lastOrderDate);

			const mm = String(date.getMonth() + 1).padStart(2, '0');
			const dd = String(date.getDate()).padStart(2, '0');
			const yyyy = date.getFullYear();

			const formattedDate = `${mm}/${dd}/${yyyy}`;

			itemsFormatted.push({
				name: item.label.replace(/,/g, ''), // remove commas to avoid errors,
				ytd: item.ytd,
				ytdVendorPercent: item.ytdVendorPercent,
				lytd: item.lytd,
				lytdVendorPercent: item.lytdVendorPercent,
				percent: item.percent,
				lastOrderDate: formattedDate
			});
		});

		var fileTitle = 'customer-vendor-totals';
		$ctrl.utils.exportCSVFile(headers, _.sortBy(itemsFormatted, 'name').reverse(), fileTitle);
	}

	isBusy() {
		const $ctrl = this;
		return $ctrl.lytdSalesQuery.isBusy() || $ctrl.ytdSalesQuery.isBusy();
	}
}
